import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import axios from 'axios';

const HOUR_LABELS = [
  '12am','1am','2am','3am','4am','5am','6am','7am','8am','9am','10am','11am',
  '12pm','1pm','2pm','3pm','4pm','5pm','6pm','7pm','8pm','9pm','10pm','11pm'
];

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{
      backgroundColor: '#1a1f2e',
      border: '1px solid #2d3748',
      borderRadius: '8px',
      padding: '10px 14px',
      fontSize: '13px'
    }}>
      <div style={{ color: '#a0aec0', marginBottom: '6px', fontWeight: '600' }}>{label}</div>
      <div style={{ color: '#00d9ff' }}>
        Opportunities: <strong>{payload[0].value}</strong>
      </div>
    </div>
  );
};

function OpportunityChart() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const offsetHours = Math.round(-new Date().getTimezoneOffset() / 60);

    axios.get(`${process.env.REACT_APP_API_URL}/api/opportunity-stats`)
      .then(res => {
        const utcFilled = Array.from({ length: 24 }, (_, i) => {
          const found = res.data.find(r => r.hour === i);
          return {
            arbs: found ? parseFloat(found.avg_arbs) : 0,
            ev: found ? parseFloat(found.avg_ev) : 0,
            bonus: found ? parseFloat(found.avg_bonus) : 0,
          };
        });

        const localFilled = Array.from({ length: 24 }, (_, i) => {
          const utcIdx = (i - offsetHours + 24) % 24;
          const d = utcFilled[utcIdx];
          return {
            hour: HOUR_LABELS[i],
            'Opportunities': Math.round((d.arbs + d.ev + d.bonus) * 10) / 10,
          };
        });

        setData(localFilled);
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, []);

  const tickFormatter = (val, idx) => idx % 2 === 0 ? val : '';

  return (
    <section style={{ padding: '80px 60px', backgroundColor: '#0a0e1a' }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#ffffff', margin: '0 0 12px 0' }}>
            Best Times to Find Opportunities
          </h2>
          <p style={{ fontSize: '16px', color: '#64748b', margin: 0 }}>
            Average number of arbitrage bets, positive EV bets, and bonus bet conversions available by hour, based on the past 7 days
          </p>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', color: '#64748b', padding: '60px 0' }}>Loading...</div>
        ) : (
          <div style={{
            backgroundColor: '#1a1f2e',
            border: '1px solid #2d3748',
            borderRadius: '16px',
            padding: '32px 24px 16px'
          }}>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={data} barCategoryGap="20%">
                <XAxis
                  dataKey="hour"
                  tickFormatter={tickFormatter}
                  tick={{ fill: '#64748b', fontSize: 11 }}
                  axisLine={{ stroke: '#2d3748' }}
                  tickLine={false}
                />
                <YAxis
                  tick={{ fill: '#64748b', fontSize: 11 }}
                  axisLine={false}
                  tickLine={false}
                  width={36}
                />
                <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(255,255,255,0.04)' }} />
                <Bar dataKey="Opportunities" fill="#00d9ff" radius={[3, 3, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
            <p style={{ fontSize: '11px', color: '#475569', textAlign: 'center', marginTop: '8px' }}>
              Times shown in your local timezone
            </p>
          </div>
        )}
      </div>
    </section>
  );
}

export default OpportunityChart;
